module.exports = __webpack_public_path__ + "6b8fd76d7be3f7d0d6d0a88c9a892478.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/mobile-apps-graphics.png
// module id = 2299
// module chunks = 1